<template>
	<div class="url-placement-data">
		<ToolCommandInputField v-model="command" />
		<ToolIconInputField class="pt-2" v-model="icon" />
		<div v-if="commandAsNameFlag" class="pt-2">
			<h5 class="message">
				Command text will be used as feature name.
				<span class="text-underline" role="button" @click="editName" @keydown.enter.space="editName" tabindex="0">Edit name</span>
			</h5>
		</div>
		<template v-else>
			<ToolNameInputField class="pt-2" v-model="name" />
			<div class="pt-2">
				<h5 class="message">
					<span class="text-underline" role="button" @click="hideName" @keydown.enter.space="hideName" tabindex="0">Hide</span>
					(Command text will be used as feature name)
				</h5>
			</div>
		</template>
	</div>
</template>

<script>
import ToolCommandInputField from './common/ToolCommandInputField.vue';
import ToolIconInputField from './common/ToolIconInputField.vue';
import ToolNameInputField from './common/ToolNameInputField.vue';
import ToolPlacementDataMixin from './ToolPlacementDataMixin';

export default {
	name: 'ToolCommandBarPlacementData',
	mixins: [ToolPlacementDataMixin],
	components: { ToolCommandInputField, ToolNameInputField, ToolIconInputField },
	methods: {
		editName() {
			this.name = this.command; // sync between them
			this.commandAsNameFlag = false;
		},
		hideName() {
			this.commandAsNameFlag = true;
		},
		getToolPlacementData() {
			return {
				command: this.command,
				name: this.commandAsNameFlag ? this.command : this.name,
				icon: this.icon.icon.name,
			};
		},
	},
	data() {
		return {
			name: '',
			command: '',
			icon: {
				icon: {
					name: 'ply-element-transparent',
					size: 12,
				},
			},
			commandAsNameFlag: true,
		};
	},
	// used in ToolPlacementDataMixin
	requiredFields: ['name', 'command'],
};
</script>

<style lang="scss" scoped>
.message {
	color: #606266;
}
</style>
